import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import {
  getMentorAndMenteeMailVariableData,
  getMentorAndMenteeMailVariables,
  MailTemplateType,
} from '../entities/mail-templates.js';

export function registerContactReminderMentee() {
  return defineMailTemplate(MailTemplateType.CONTACT_REMINDER_MENTEE, {
    getMailData: getMentorAndMenteeMailVariableData,
    defaultTemplate: {
      subject: `Mentoring-Programm: Bitte nehmen Sie Kontakt auf`,
      content: `<p>Hallo {{mentee.firstName}},<br></p>
        <p> Dein:e Mentor:in {{montor.firstName}}&nbsp;{{mentor.lastName}} hat uns kontaktiert, weil Du nach einem Kontaktversuch noch nicht geantwortet hast. Hattest Du vielleicht keine Zeit oder gab es technische oder sonstige Schwierigkeiten für Dich Deine:n Mentor:in zu kontaktieren? Vielleicht ist die Mail aus Versehen in Deinem Spamfilter gelandet, sodass Du sie noch nicht gesehen hast. </p>
        <p> Bitte gib uns eine kurze Rückmeldung und schreibe {{mentor.firstName}} {{lastNameOther}}&nbsp;in den nächsten Tagen unter {{mentor.email}}, da es natürlich schön wäre, wenn Ihr Euch schon bald kennenlernen könntet. </p><p>Solltest Du nicht mehr am Programm teilnehmen wollen, melde Dich bitte per Mail ab.&nbsp;</p>
        <p> Viele Grüße, </p>
        <p> Dein Mentoring-Team</p>`,
      footer: '',
    },
    variables: getMentorAndMenteeMailVariables(),
    attachments: [],
    displayName: 'Kontakterinnerung: Mentee',
    editorHint: () =>
      'Mail wird verschickt, wenn sich ein Nutzer bei der Registrierung mit einem 4-Stelligen Code authentifizieren muss.',
  });
}
